import React, { useEffect, useState } from "react";
import "../css/home.scss";
import Header from "../pages/Header";
import SiderBar from "../pages/SiderBar";
import { Outlet } from "react-router-dom";
import { setAPIAuthorizationToken } from "../apis/API";
import Cookies from "js-cookie";
import Footer from "../pages/Footer";
import { LocaleProvider } from "../contexts/LocaleContext";

const Home = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  // mobile sidebar open state (hidden by default on small screens)
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  // 初始化token
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setAPIAuthorizationToken(token);
    }
  }, []);

  return (
    <LocaleProvider>
      <div
        className={`home-container ${mobileSidebarOpen ? "sidebar-open" : ""}`}
      >
        <Header
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          setMobileSidebarOpen={setMobileSidebarOpen}
        />
        <SiderBar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          mobileOpen={mobileSidebarOpen}
          onMobileClose={() => setMobileSidebarOpen(false)}
        />
        <main className={`content-wrapper ${isCollapsed ? "collapsed" : ""}`}>
          <Outlet context={{ isCollapsed }} />
          <Footer isCollapsed={isCollapsed} />
        </main>
      </div>
    </LocaleProvider>
  );
};

export default Home;
